class ContentOverlay {
	constructor(el) {
		this.root = el;
		this.closeButtons = Array.from(el.querySelectorAll('.js-contentOverlayClose'));
		this.closeButtons.forEach(closeButton =>
			closeButton.addEventListener('click', this.onClick.bind(this))
		);
	}

	onClick(e) {
		this.root.classList.remove('is-open');
	}
}
document.querySelectorAll('.js-contentOverlay').forEach(el => new ContentOverlay(el));
